import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { store } from '@/store';
import VueProgrammaticInvisibleGoogleRecaptcha from 'vue-programmatic-invisible-google-recaptcha';
import userAgent from '@/services/userAgent.service';
import { useValidator } from '@/core/app.service';
import ImageUpload from '@/ui/shared/imageupload/ImageUpload.vue';
import YourStoriesFormBlockWebRequest = Vertica.LouisPoulsen.Application.Content.Requests.YourStoriesFormBlockWebRequest;
import PageService from '@/core/page.service';
import dictionaryService from '@/core/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockYourStoriesForm',
  props: {
    confirmationPageUrl: null
  },
  setup(__props: any) {

const props = __props as {confirmationPageUrl: string}



const recaptchaKey = computed<string>(() => store.getters['app/recaptchaKey']);
const previewImages = ref<CarouselImageWithExtension[]>([]);

function submitYourStoriesForm(request: YourStoriesFormBlockWebRequest): Promise<string> {
    return store.dispatch('traderform/submitYourStoriesForm', request);
}

const submittingFormData = ref<boolean>(false);

const _uid = Math.floor(Math.random() * 1000000).toString();
const recaptchaComponentId = 'yourStoriesFormRecaptcha';
const imageUploadComponent = ref(null);

const refs = { [recaptchaComponentId + _uid]: ref(null) };

const request = ref<YourStoriesFormBlockWebRequest>({ email: '', biography: '', recaptchaToken: '' });

function setRecaptchaRef(el: any) {
    setTimeout(() => {
        refs[recaptchaComponentId + _uid].value = el;
    }, 100);
}
const runAnimations = ref<boolean>(userAgent.isPrerender);

function initAnimations(): void {
    runAnimations.value = true;
}

const $validator = useValidator();

$validator.extend(
    'image_filesize', {
        getMessage: _ => dictionaryService.get('Pages.YourStories.FormLabels.ImageFileSizeErrorMessage'),
        validate: _ => {
            let totalSize = 0;
            const images = imageUploadComponent.value as Vue;
            const imageInput: HTMLInputElement = images.$refs.imageUploadFiles as HTMLInputElement;
            for (const file of imageInput.files) {
                totalSize += file.size;
            }
            return totalSize < 20 * 1024 * 1024;
        }
    });

function validateAndSubmitRequest() {
    $validator.validateAll()
        .then(isValid => {
            if (isValid) {
                const recaptchaComponent = refs[recaptchaComponentId + _uid].value as any;
                recaptchaComponent.execute();
            } else {
                scrollInvalidElementIntoView();
            }
        });
}

const imageFiles = computed<FileList>(() => {
    const imageUpload = imageUploadComponent.value as Vue;
    return (imageUpload.$refs.imageUploadFiles as HTMLInputElement).files;
});

function submitForm(recaptchaToken: string) {
    submittingFormData.value = true;
    request.value.recaptchaToken = recaptchaToken;

    const formData: any = new FormData();

    for (const key of Object.keys(request.value)) {
        const value = request.value[key];
        if (value) {
            formData.append(key, value);
        }
    };

    if (imageUploadComponent.value) {
        for (let i = 0; i < imageFiles.value.length; i++) {
            formData.append('imageUpload[]', imageFiles.value[i], imageFiles.value[i].name);
        }
    }

    submitYourStoriesForm(formData as YourStoriesFormBlockWebRequest).then(
        () => {
            submittingFormData.value = false;
            PageService.softRedirect(props.confirmationPageUrl);
        },
        () => {
            submittingFormData.value = false;
        }
    );
}

function scrollInvalidElementIntoView() {
    const firstInvalidElement = document.querySelector('.is-danger');
    if (firstInvalidElement) {
        firstInvalidElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
}

function onImagesPreviewChange(images: CarouselImageWithExtension[]) {
    previewImages.value = images;
}


return { __sfc: true,props, recaptchaKey, previewImages, submitYourStoriesForm, submittingFormData, _uid, recaptchaComponentId, imageUploadComponent, refs, request, setRecaptchaRef, runAnimations, initAnimations, $validator, validateAndSubmitRequest, imageFiles, submitForm, scrollInvalidElementIntoView, onImagesPreviewChange, VueProgrammaticInvisibleGoogleRecaptcha, ImageUpload }
}

})